import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=72c4ba10&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=72c4ba10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4ba10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c4ba10')) {
      api.createRecord('72c4ba10', component.options)
    } else {
      api.reload('72c4ba10', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=72c4ba10&scoped=true&", function () {
      api.rerender('72c4ba10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Staff/Login.vue"
export default component.exports